
export default {
    root: {
        outline: {
            width: '2px',
            color: '{content.background}'
        }
    }
};
